import {getConnectOptionDisplayName} from "../../lib/institutionDisplayNames.ts";

export type InstitutionOption = {
    id: string
    name: string
    logo: string | null
    connection_method?: string
    is_connected?: boolean
    transaction_total_days?: string | null
}

type Props = {
    items: InstitutionOption[]
    onItemClick: (item: InstitutionOption) => void
    isItemDisabled?: (item: InstitutionOption) => boolean
    disabledFeedback?: string
}

export function InstitutionOptionList({items, onItemClick, isItemDisabled, disabledFeedback}: Props) {
    return (
        <div className="flex flex-col md:flex-row flex-wrap gap-2 md:gap-6 flex-1 mt-4">
            {items.map((item) => {
                const disabled = isItemDisabled?.(item) ?? false
                const displayName = getConnectOptionDisplayName(item)

                return (
                    <button
                        key={item.id}
                        type="button"
                        disabled={disabled}
                        title={disabled ? disabledFeedback : undefined}
                        onClick={() => onItemClick(item)}
                        className={
                            'flex items-center md:block no-underline bg-white px-4 py-2 rounded-xl border-2 border-gray-100 ' +
                            (disabled
                                ? 'opacity-50 cursor-not-allowed border-gray-100'
                                : 'hover:border-blue-200 cursor-pointer')
                        }
                    >
                        {item.logo && (
                            <img
                                src={item.logo}
                                alt={displayName}
                                className="w-8 m-2 md:w-32 md:m-8"
                            />
                        )}
                        <h3 className="text-sm text-gray-400 text-right md:text-center md:max-w-24 mx-auto md:self-stretch md:pb-2">
                            {displayName}
                        </h3>
                    </button>
                )
            })}
        </div>
    )
}
